import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import { TaxonomyType } from '@stereoagency/constants';
import taxonomy from '../documents/taxonomy.js';
import arrayEntry from '../fragments/arrayEntry.js';
import sanityReference from '../fragments/sanityReference.js';
import callToAction from './callToAction.js';
var schema = defineObject('researchPlatformListingSection', {
    enableTaxonomyFilter: {
        title: 'Enable taxonomy filter (user selectable)',
        type: 'boolean'
    },
    staticFilter: {
        title: 'Static filter (only show matching entries)',
        type: 'array',
        of: [
            {
                type: 'reference',
                to: [
                    {
                        type: 'taxonomy'
                    }
                ],
                options: {
                    filter: 'type in $types',
                    filterParams: {
                        types: [
                            TaxonomyType.DISEASE_AREA
                        ]
                    }
                }
            }
        ]
    },
    title: {
        type: 'string',
        title: 'Title'
    },
    subtitle: {
        type: 'string',
        title: 'Subtitle'
    },
    action: {
        type: 'callToAction',
        title: 'Call to action'
    },
    hideCardImages: {
        type: 'boolean',
        title: 'Hide card images'
    }
}, [
    taxonomy.schema.taxonomy,
    callToAction.schema.callToAction
]);
var validator = z.object({
    enableTaxonomyFilter: z.boolean(),
    staticFilter: z.array(sanityReference.validator.merge(arrayEntry.validator)),
    hideCardImages: z.boolean()
}).partial();
schema.researchPlatformListingSection;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=researchPlatformListingSection.js.map